export const RADIO_GROUP_ORIENTATIONS = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
}
